import { styled } from '../../Styles/stitches.config'
import { StyledSVG } from '../../Atoms'

export const StyledButtonLink = styled('button', {
    bgc: '$primary200',
    border: 'none',
    borderRadius: '$1',
    color: '$neutral600',
    cursor: 'pointer',
    display: 'grid',
    gap: '$1',
    justifyItems: 'start',
    padding: '$3',
    placeContent: 'start',
    transition: '$default',

    [`& ${StyledSVG}`]: {
        size: 18,
    },

    '&:hover': {
        boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.25)',
        transform: 'translateY(-2px)',
    },

    variants: {
        inline: {
            true: {
                gap: '$2',
                gridAutoFlow: 'column',
            },
        },
    },
})
